module.exports = __webpack_public_path__ + "static/media/doctor1.e4c03519.webp";